import type {
  VesselSearcherColumn,
  VesselSearcherNullableBoolean,
  VesselSearcherNullableNumber,
  VesselSearcherNullableText,
} from "../models/vessel-searcher.models";
import axios from "axios";

export const formatVesselSearcherValue = (
  value: VesselSearcherNullableText | VesselSearcherNullableNumber | VesselSearcherNullableBoolean,
): string => {
  if (value === null || value === "") {
    return "";
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (typeof value === "number") {
    return value.toLocaleString("en-US", { maximumFractionDigits: 2 });
  }

  return value;
};

export const formatVesselSearcherCell = (
  column: VesselSearcherColumn,
  value: VesselSearcherNullableText | VesselSearcherNullableNumber | VesselSearcherNullableBoolean,
): string => {
  if (typeof value === "string" && (column.key === "buildDate" || column.key === "keelLaidDate")) {
    return value.slice(0, 7);
  }

  if (typeof value === "string" && (column.key === "lastInspection" || column.key === "lastFixtureDate")) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return "";
    }

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "short", timeZone: "UTC" });
    const year = String(date.getUTCFullYear()).slice(-2);

    return `${day}-${month}-${year}`;
  }

  return formatVesselSearcherValue(value);
};

export const getVesselSearcherErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError<{ detail?: string; error?: string; message?: string }>(error)) {
    return error.response?.data?.detail
      ?? error.response?.data?.error
      ?? error.response?.data?.message
      ?? "Vessels could not be loaded.";
  }

  return "Vessels could not be loaded.";
};
